import { useCallback, useContext } from 'react';
import { Button } from 'foundations-components/transitional/components/Button';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { HR } from 'foundations-components/transitional/components/HR';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import SubmitButton from 'LoginUI/components/legacyLogins/shared/SubmitButton';
import EmailInputForm from 'LoginUI/components/legacyLogins/shared/EmailInputForm';
import RememberMeCheckbox from 'LoginUI/components/legacyLogins/shared/RememberMeCheckbox';
import { SmartLoginLandingPageContext } from './SmartLoginLandingPageContext';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const StagedEmailComponent = ({
  email,
  changeEmail
}) => {
  return /*#__PURE__*/_jsxs(View, {
    marginBlockStart: "600",
    as: "div",
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "login.smartLogin.welcome"
    }), /*#__PURE__*/_jsxs(TFlex, {
      direction: "row",
      align: "end",
      justify: "between",
      children: [/*#__PURE__*/_jsx(Text, {
        as: "strong",
        children: /*#__PURE__*/_jsx(TruncateString, {
          maxWidth: 310,
          children: email
        })
      }), /*#__PURE__*/_jsx(Button, {
        use: "link",
        onClick: changeEmail,
        marginInlineStart: "200",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "login.smartLogin.changeEmail"
        })
      })]
    }), /*#__PURE__*/_jsx(HR, {
      distance: "small"
    })]
  });
};
const EmailComponent = () => {
  const {
    isEmailSet,
    setEmail,
    onClickNext,
    useDark,
    submitting,
    email,
    rememberLogin,
    toggleRememberLogin,
    onClickChangeEmail
  } = useContext(SmartLoginLandingPageContext);
  const handleClickNext = useCallback(evt => {
    evt.preventDefault();
    onClickNext();
  }, [onClickNext]);
  return /*#__PURE__*/_jsx("div", {
    children: isEmailSet ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(StagedEmailComponent, {
        email: email,
        changeEmail: onClickChangeEmail
      }), /*#__PURE__*/_jsx(RememberMeCheckbox, {
        checked: rememberLogin,
        onChange: toggleRememberLogin,
        disabled: submitting
      })]
    }) : /*#__PURE__*/_jsxs("form", {
      onSubmit: handleClickNext,
      children: [/*#__PURE__*/_jsx(EmailInputForm, {
        useDark: useDark,
        onEmailChange: setEmail,
        submitting: submitting,
        email: email
      }), /*#__PURE__*/_jsx("input", {
        type: "password",
        hidden: true
      }), /*#__PURE__*/_jsx(SubmitButton, {
        submitting: false,
        disabled: !true,
        keyword: "next"
      })]
    })
  });
};
export default EmailComponent;